import { useQuery } from "@tanstack/react-query";
import { api, throwIfError } from "../client";
import { fleetMeasurementKeys } from "../query-keys";
import type { EventId } from "@/types/identifiers";

export function useFleetYawMeasurements(eventId: EventId) {
  return useQuery({
    queryKey: fleetMeasurementKeys.yaw(eventId),
    queryFn: async () => {
      const result = await api.GET("/api/events/{event_id}/fleet-measurements/yaw", {
        params: { path: { event_id: eventId } },
      });
      return throwIfError(result, "Failed to fetch fleet yaw measurements");
    },
    enabled: !!eventId,
  });
}

export function useFleetSteeringMeasurements(eventId: EventId) {
  return useQuery({
    queryKey: fleetMeasurementKeys.steering(eventId),
    queryFn: async () => {
      const result = await api.GET("/api/events/{event_id}/fleet-measurements/steering", {
        params: { path: { event_id: eventId } },
      });
      return throwIfError(result, "Failed to fetch fleet steering measurements");
    },
    enabled: !!eventId,
  });
}

export function useFleetDbHeightMeasurements(eventId: EventId) {
  return useQuery({
    queryKey: fleetMeasurementKeys.dbHeight(eventId),
    queryFn: async () => {
      const result = await api.GET("/api/events/{event_id}/fleet-measurements/db-height", {
        params: { path: { event_id: eventId } },
      });
      return throwIfError(result, "Failed to fetch fleet DB height measurements");
    },
    enabled: !!eventId,
  });
}
